<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="displayGoBack">
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3
                v-for="group in groups"
                :key="group.identifier"
        >
            <!--The card representing the Group can be defined with 2 elements:
            1 - image   2 - title
            It is mandatory to have an image to be displayed-->
            <v-card hover v-if="group.sub_groups && group.sub_groups.length > 0" @click="goToGroup(group.id)"
                    :class="[!group.image ? 'catalog-group-card no-card-image' : 'catalog-group-card']">
                <v-img v-if="group.image && baseUrl" v-bind:src="baseUrl + group.image" aspect-ratio="1.48"></v-img>
                <!--                <v-img v-if="!group.image" :src="require('@/assets/no-photo.jpg')" aspect-ratio="1.48"></v-img>-->

                <v-card-title primary-title>
                    <div :class="[group.image ? 'headline text-truncate primary--text' : 'headline primary--text']">
                        {{ group.description }}
                    </div>
                </v-card-title>
            </v-card>
            <v-card hover v-else @click="goToGroupDetail(group.id)"
                    :class="[!group.image ? 'catalog-group-card no-card-image' : 'catalog-group-card']">
                <v-img v-if="group.image && baseUrl" v-bind:src="baseUrl + group.image" aspect-ratio="1.48"></v-img>
                <!--                <v-img v-if="!group.image" :src="require('@/assets/no-photo.jpg')" aspect-ratio="1.48"></v-img>-->

                <v-card-title primary-title>
                    <div :class="[group.image ? 'headline text-truncate primary--text' : 'headline primary--text']">
                        {{ group.description }}
                    </div>
                </v-card-title>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {groupsService} from '@/_services/shop/groups.service';
import {getErrorMessage} from '@/_helpers';
import {mapGetters} from "vuex";

export default {
    name: "Catalog",
    data: () => {
        return {
            groupIdentifier: null,
            groupGroupParentIdentifier: null,
            backGroupIdentifier: null,
            displayGoBack: false,
            groups: [],
        }
    },
    computed: {
        ...mapGetters({
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    methods: {
        /**
         * This function is triggered when the user selects a Group to access its detail;
         * this works as a redirect to the Groups's detail interface
         * @param pk
         **/
        goToGroupDetail: function (pk) {
            this.$router.push({name: 'shop-group-detail-items', params: {group: pk}})
        },
        /**
         * This function is triggered when the user selects a Group to access its detail;
         * and the Group has more Groups inside, instead of Items.
         * @param pk
         **/
        goToGroup: function (pk) {
            this.$router.push({name: 'shop-group-detail', params: {id: pk}})
        },
        /**
         *
         *
         **/
        goBack: function () {
            if (this.groupGroupParentIdentifier) {
                this.$router.push({name: 'shop-group-detail', params: {id: this.groupGroupParentIdentifier}})
            } else {
                this.$router.push({name: 'catalog'})
            }
        },
        /**
         * This method is triggered when entering this view. It aims at identifying if the information to display
         * on the Group's Detail is: (1) the Items of the Group; (2) other Groups.
         * @param pk
         */
        getGroupInfo(pk) {
            this.groupIdentifier = parseInt(pk);
            if (!this.groupIdentifier) {
                this.displayGoBack = false;
                groupsService.getAll({level: 1}).then(result => {
                        this.groups = result.results;
                        this.$store.dispatch("loader/setLoading", false);
                    },
                    // eslint-disable-next-line
                    error => {
                        getErrorMessage(error, 'Getting the Groups', this);
                        // this.$router.push({name: 'home'})
                    }
                );
            } else {
                groupsService.get(this.groupIdentifier).then(result => {
                        this.groups = result.sub_groups;
                        this.groupGroupParentIdentifier = this.groups[0].parent_group_group;
                        this.displayGoBack = true;
                        this.$store.dispatch("loader/setLoading", false);

                        //The change of the toolbar title has to be managed inside the promise where the item is obtained
                        // After setting the meta, it is necessary to force the router to reload.
                        // Which is achieved by changing the query parameter
                        this.$route.meta.toolbarTitle = this.groups[0].parent_group_description;
                        // Add a temporary query parameter.
                        this.$router.replace({query: {temp: Date.now()}});
                        // Remove the temporary query parameter.
                        this.$router.replace({query: {temp: undefined}});

                    },
                    error => {
                        getErrorMessage(error, 'Getting the Group Sub-Groups', this);
                    }
                );
            }
        }
    },
    watch: {
        /**
         * https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes
         * To react to params changes in the same component, it is necessary to watch the $route object
         * @param to
         * @param from
         */
        $route(to, from) {
            var toGroupIdentifier = to.params.id;
            var fromGroupIdentifier = from.params.id;
            if (!fromGroupIdentifier || toGroupIdentifier !== fromGroupIdentifier) {
                this.backGroupIdentifier = fromGroupIdentifier;
                this.getGroupInfo(toGroupIdentifier);
            }
        }
    },
    mounted() {
        this.$store.dispatch("loader/setLoading", true);

        this.getGroupInfo(this.$route.params.id);
    }
}
</script>

<style scoped>

</style>